import React, { useState, useEffect } from 'react';
// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import hauntedService from 'services/hauntedService';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
  const [hasHauntedAccess, setHasHauntedAccess] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const checkAccess = async () => {
      try {
        const studentToken = localStorage.getItem('studentToken');
        if (!studentToken) return;
        const res = await hauntedService.getMyGroup();
        const hasAccess = res.data?.data?.has_access ?? res.data?.has_access;
        if (isMounted && hasAccess) {
          setHasHauntedAccess(true);
        }
      } catch (err) {
        // silent: not assigned or not logged in
      }
    };
    checkAccess();
    return () => {
      isMounted = false;
    };
  }, []);

  const filteredItems = menuItem.items.filter((item) => {
    if (item.id === 'haunted') {
      return hasHauntedAccess;
    }
    return true;
  });

  const navItems = filteredItems.map((item) => {
    if (item.children && item.children.length !== 0) {
      switch (item.type) {
        case 'group':
          return <NavGroup key={item.id} item={item} />;
        default:
          return (
            <Typography key={item.id} variant="h6" color="error" align="center">
              Menu Items Error
            </Typography>
          );
      }
    }
    return null;
  });

  return <>{navItems}</>;
};

export default MenuList;
